import { useEffect, useState } from 'react'
import { useAuth } from '../../features/auth/AuthContext'
import { apiClient, apiOrigin } from '../../lib/apiClient'
import { getInitials } from '../../utils/text'

function Photo({ url, name }: { url: string; name: string }) {
  const [source, setSource] = useState('')
  useEffect(() => {
    const controller = new AbortController()
    let objectUrl = ''
    const target = new URL(url, apiOrigin)
    // Patient photographs remain protected and are loaded using the authenticated API client.
    if (target.origin === apiOrigin) {
      void apiClient.get<Blob>(target.href, { responseType: 'blob', signal: controller.signal }).then(response => {
        if (controller.signal.aborted || !['image/jpeg', 'image/png', 'image/webp'].includes(response.data.type.split(';')[0])) return
        objectUrl = URL.createObjectURL(response.data)
        setSource(objectUrl)
      }).catch(() => {})
    }
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl) }
  }, [url])
  return source ? <img src={source} alt={`${name} profile`} className="avatar avatar-sm user-avatar-image" onError={() => setSource('')} /> : <span className="avatar avatar-sm" aria-hidden="true">{getInitials(name)}</span>
}

export default function UserAvatar({ name }: { name: string }) {
  const { user } = useAuth()
  return user?.photo_url ? <Photo key={user.photo_url} url={user.photo_url} name={name} /> : <span className="avatar avatar-sm" aria-hidden="true">{getInitials(name)}</span>
}
